import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import { AudioToggleModalProps } from '../interfaces/components';
import { useTranslation } from 'react-i18next';

const AudioToggleModal = ({ active, proceedAudio }: AudioToggleModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.1)"
        transition="all 1s"
        zIndex={4}
        onClick={() => proceedAudio(false)}
      />
      <Box
        zIndex="999999"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '15px', '15px', '15px']}
        width={['85vw', '350px', '550px', '550px', '550px']}
        height={['150px', '170px', '200px', '200px', '200px']}
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
        flexDir="column"
      >
        <Box
          color="black"
          textAlign="center"
          fontSize={['12px', '14px', '14px', '16px', '16px']}
          className="copy"
          fontFamily="SangBleuBPLight"
        >
          {t('audio-prompt')}
        </Box>
        <Box display="flex" justifyContent="space-evenly" alignItems="center" w={['100%', '100%', '70%', '70%']}>
          <Button
            variant="outline"
            borderColor="black"
            color="black"
            borderRadius="0px"
            h={['30px', '40px', '40px', '50px', '50px']}
            w={['80px', '120px', '140px', '140px']}
            bg="white"
            fontSize={['12px', '14px', '14px', '16px', '16px']}
            _hover={{ bg: 'white' }}
            _active={{ bg: 'white' }}
            _focus={{ bg: 'white' }}
            cursor="pointer"
            onClick={() => {
              proceedAudio(true);
            }}
            pointerEvents="auto"
            className="copy"
            fontFamily="SangBleuBPLight"
          >
            {t('audio-prompt-yes')}
          </Button>
          <Button
            variant="outline"
            borderColor="black"
            color="black"
            borderRadius="0px"
            h={['30px', '40px', '40px', '50px', '50px']}
            w={['80px', '120px', '140px', '140px']}
            bg="white"
            fontSize={['12px', '14px', '14px', '16px', '16px']}
            _hover={{ bg: 'white' }}
            _active={{ bg: 'white' }}
            _focus={{ bg: 'white' }}
            cursor="pointer"
            onClick={() => {
              proceedAudio(false);
            }}
            pointerEvents="auto"
            className="copy"
            fontFamily="SangBleuBPLight"
          >
            {t('audio-prompt-no')}
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default AudioToggleModal;
